import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastNotificationService } from './toast-notification.service';

@Component({
  selector: 'app-toast-notification',
  templateUrl: './toast-notification.component.html',
  styleUrls: ['./toast-notification.component.css']
})
export class ToastNotificationComponent implements OnInit {
  @ViewChild('trigger') Input: ElementRef | undefined;
  @ViewChild('toasterError') InputError: ElementRef | undefined;

title = '{Action} complete';
message = 'Your {record type} were successfully {actioned}.'

isSuccess = false;
isError = false;
isAmend: boolean=false;

  constructor(private toastService:ToastNotificationService, private router: Router) { }

  ngOnInit(): void {
    this.success();
    this.error();
    this.getAmendUserScreen();
  }
success(){
  this.toastService.getSucess().subscribe(x => {
    if(x.title != '' && x.message){
      this.isSuccess = true;
      this.isError = false;
      this.title = x.title;
      this.message = x.message;
      let inputElement: HTMLElement = this.Input?.nativeElement as HTMLElement;
      inputElement.click();
    }
  })
}

error(){
  this.toastService.getError().subscribe(x => {
    if(x.title != '' && x.message){
      this.isSuccess = false;
      this.isError = true;
      this.title = x.title;
      this.message = x.message;
      let inputElement: HTMLElement = this.InputError?.nativeElement as HTMLElement;
      inputElement.click();
    }
  })
}

getAmendUserScreen()
{
  if 
  (this.router.url.indexOf('ammenduser')){
    this.isAmend = true;
  }
}
}
